import AuthImage from "./AuthImage"

const LoginBox = ({ children }) => {
  return (
    <div className="px-4 py-12 mx-auto max-w-7xl sm:px-6 md:px-12 lg:px-24 lg:py-24">
        <div className="justify-center mx-auto text-left align-bottom transition-all transform bg-slate-200 rounded-lg sm:align-middle sm:max-w-2xl sm:w-full">
            <div className="grid flex-wrap items-center justify-center grid-cols-1 mx-auto shadow-xl lg:grid-cols-2 rounded-xl">
                { children }

                <div className="order-first hidden w-full h-full lg:block">
                    <AuthImage className="h-full object-cover bg-cover rounded-l-lg" />
                </div>
            </div>
        </div>
    </div>
  )
}

export default LoginBox
